<template>
  <div>
    <!-- 返回 -->
    <div class="return">
      <router-link to="/">返回首页</router-link>
    </div>
    <!-- 返回 -->
    <!-- 内容 -->
    <div class="container">
      <!-- 一级标题 -->
      <h2 class="title1">保养的重要性</h2>

      <div class="container-content">
      <h3 class="title2">保养的重要性</h3>
        <p>务必保持您的摩托车处于良好的保养维护状态，这对您的安全，以及保护您的财产、获得最佳性能、防止故障和减轻空气污染至关重要。进行保养是摩托车主的责任。确保在每次骑行前都进行检查，而且按<router-link to="/block17/byzqb">保养周期表</router-link>中的说明进行定期检查。</p>

      <div class="warningbox">
          <div class="top">
            <span>警告</span>
          </div>
          <div class="line">
            <p>骑行前未能进行正常保养或未能正确解除故障都可能引发导致重伤或致命的事故。</p>
            <p>请一直遵循本《使用说明书》中提供的检查、保养建议和保养周期表。</p>
          </div>
        </div>

      <h3 class="title2">保养的安全性</h3>

        <p>请在每次维护保养前阅读保养说明，确保您具备了必要的工具、部件和技能。我们无法提醒您在进行保养时可能出现的每一个危险。只有您自己才能决定是否应该执行保养维修。</p>

        <p>保养时请遵循下列指南。</p>
        <ul class="circle">
          <li>熄灭发动机，然后将点火开关转到 <img src="../img/zhinankaiguan.png"  class="icon_middle"/>（关闭）位置。</li>
          <li>使用侧支架、中心支架或保养支架提供支撑，将您的摩托车停在坚固、平坦的地面上。</li>
          <li>请在开始维修前等待发动机、消音器、制动器和其他高温部件冷却，否则会烫伤。</li>
          <li>只在指定情况下启动发动机，而且要在良好通风的环境下。</li>
          </ul>

        <!-- 锚点定位 -->
      </div>
      <!-- 上一页 下一页 -->
      <div class="foot-btn clearfix">
        <div class="prev">
          <router-link to="/block15a">上一页</router-link>
        </div>
        <div class="next">
          <router-link to="/block17">下一页</router-link>
        </div>
      </div>
      <!-- 上一页 下一页 -->
    </div>
    <!-- 内容 -->
  </div>
</template>

<script>
export default {
  props: ["id"],
  watch: {
    $route(to, from) {
      if (this.id != null) {
        setlink(this);
      }
    }
  },
  mounted() {
    setlink(this);
    // 图像热区
    //imagehoverclick("boxmap");
  },
  methods: {
    goto(path) {
      this.$router.push({ path: path });
    }
  }
};
</script>
